'use strict';

const registry = new Map();

const markerClass = (name) => `js-w-${name}`;

export const Widgets = {
    /**
     * @param {string} name value used in the `data-widget` attribute
     * @param {function(jQuery, object): void} init receives the element and its data attributes
     * @param {{isInitialized: function(jQuery): boolean}} [options]
     */
    register(name, init, options = {}) {
        registry.set(name, { init, isInitialized: options.isInitialized ?? null });
    },

    init(scope) {
        const $scope = $(scope ?? document);

        registry.forEach(({ init, isInitialized }, name) => {
            const marker = markerClass(name);
            const selector = `[data-widget~="${name}"]`;

            let $elements = $scope.find(selector).addBack(selector);

            if (scope === undefined) {
                $elements = $elements.not('[data-widget-defer]');
            }

            $elements
                .each((index, element) => {
                    const $element = $(element);

                    if (isInitialized !== null ? isInitialized($element) : $element.hasClass(marker)) {
                        return;
                    }

                    if (isInitialized === null) {
                        $element.addClass(marker);
                    }

                    init($element, $element.data());
                });
        });
    },
};

$(() => Widgets.init());

if (typeof $.nette !== 'undefined' && $.nette.ext) {
    $.nette.ext('widgets', {
        complete: () => Widgets.init(),
    });
}
